import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import PatientInfoModal from './PatientInfoModal';

const WhatsAppBooking = ({ t }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('regular');

  useEffect(() => {
    // Show notification after 5 seconds for first-time visitors
    const timer = setTimeout(() => {
      if (!localStorage.getItem('whatsapp-seen')) {
        setShowNotification(true);
        localStorage.setItem('whatsapp-seen', 'true');
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, []);



  const handleBookingClick = (messageType) => {
    setModalType(messageType);
    setShowModal(true);
    setIsExpanded(false);
    setShowNotification(false);
  };

  const handleModalSubmit = (formattedMessage) => {
    const phoneNumber = "919123860262"; // Dr. Pritish's WhatsApp number
    const message = encodeURIComponent(formattedMessage);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
    
    window.open(whatsappURL, '_blank');
    setShowModal(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* Notification Bubble */}
      {showNotification && (
        <div className="whatsapp-notification animate-bounce-in">
          <div className="notification-content">
            <span className="notification-text">📱 Book instantly via WhatsApp!</span>
            <button 
              className="notification-close"
              onClick={() => setShowNotification(false)}
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}

      {/* Main WhatsApp Widget */}
      <div className={`whatsapp-widget ${isExpanded ? 'expanded' : ''}`}>
        {/* Booking Popup */}
        {isExpanded && (
          <div className={`booking-popup ${isExpanded ? 'show' : ''}`}>
            <div className="popup-header">
              <div className="popup-title">📱 Book via WhatsApp</div>
              <small>Choose your booking type below</small>
            </div>

            <div className="booking-options">
              <button 
                className="booking-option-btn"
                onClick={() => handleBookingClick('regular')}
              >
                <span className="btn-icon">�</span>
                <div className="btn-content">
                  <strong>Regular Appointment</strong>
                  <small>Schedule your treatment session</small>
                </div>
              </button>

              <button 
                className="booking-option-btn"
                onClick={() => handleBookingClick('urgent')}
              >
                <span className="btn-icon">⚡</span>
                <div className="btn-content">
                  <strong>Urgent Booking</strong>
                  <small>Same day or urgent consultation</small>
                </div>
              </button>

              <button 
                className="booking-option-btn"
                onClick={() => handleBookingClick('inquiry')}
              >
                <span className="btn-icon">❓</span>
                <div className="btn-content">
                  <strong>General Inquiry</strong>
                  <small>Questions about treatment</small>
                </div>
              </button>

              <button 
                className="booking-option-btn"
                onClick={() => handleBookingClick('emergency')}
              >
                <span className="btn-icon">🆘</span>
                <div className="btn-content">
                  <strong>Emergency</strong>
                  <small>Immediate help needed</small>
                </div>
              </button>
            </div>

            <div className="clinic-hours">
              <small>
                ⏰ <strong>Clinic Hours:</strong> Mon-Sat 9AM-9PM
                <br />
                📍 <strong>Location:</strong> Physio Sphere, Sambalpur
              </small>
            </div>
          </div>
        )}

        {/* Main WhatsApp Button */}
        <button 
          className="whatsapp-main-btn animate-heartbeat hover-bounce"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-label="WhatsApp Booking"
        >
          {isExpanded ? <FaTimes /> : <FaWhatsapp />}
        </button>

        {/* Pulse Ring Animation */}
        <div className="pulse-ring"></div>
      </div>

      {/* Overlay when expanded */}
      {isExpanded && (
        <div 
          className={`whatsapp-overlay ${isExpanded ? 'show' : ''}`}
          onClick={() => setIsExpanded(false)}
        />
      )}

      {/* Patient Info Modal */}
      <PatientInfoModal
        show={showModal}
        onHide={handleModalClose}
        onSubmit={handleModalSubmit}
        type={modalType}
        title={
          modalType === 'regular' ? 'Book Appointment' :
          modalType === 'urgent' ? 'Urgent Appointment' :
          modalType === 'emergency' ? 'Emergency Booking' :
          modalType === 'inquiry' ? 'General Inquiry' :
          'Contact Information'
        }
      />
    </>
  );
};

export default WhatsAppBooking;